<template>
    <PostsBlock :posts="posts" :menu-categories="menuCategories" @category="selectedCategoryIndex = $event"
        :startCategories="this.mostRecentCategories" />
</template>

<script>
import PostsBlock from "./PostsBlock.vue"

export default {
    name: 'NewsComponent',
    components: {
        PostsBlock,
    },
    props: {
        category: {
            type: String,
            default: null,
        },
        categories: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            selectedCategoryIndex: 0,
            postsSlideIndex: 0,
            buttonWidth: "100%",
        }
    },
    methods: {
    },
    computed: {
        postsCategory() {
            if (this.menuCategories.length) {
                return this.menuCategories[this.selectedCategoryIndex]
            }
            if (this.category == null) {
                return null
            }
            return this.$store.getters["categories/slug"](this.category)
        },
        menuCategories() {
            if (this.categories == null) {
                return []
            }
            return this.$store.getters["categories/slugs"](this.categories)
        },
        mostRecentCategories() {
            let post = this.$store.getters["posts/all"](1)[0]
            if (post == null) {
                return []
            }
            return post.categories
        },
        posts() {
            if (this.postsCategory != null) {
                return this.$store.getters["posts/category"](this.postsCategory, null, true)
            }
            if (this.category == null) {
                return this.$store.getters["posts/all"](3)
            }
            return []
        },
    },
    watch: {
        postsCategory() {
            this.postsSlideIndex = 0
            if (this.postsCategory == null) {
                return
            }
            this.$store.dispatch("posts/getCategory", this.postsCategory)
        },
        posts: {
            immediate: true,
            handler() {
                if (this.category != null) {
                    return
                }
                const post = this.posts[0]
                if (post == null) {
                    return
                }
                // this.selectedCategoryIndex = 0
                // for (let category of this.menuCategories) {
                //     if (post.categories.includes(category.id)) {
                //         break
                //     }
                //     this.selectedCategoryIndex += 1
                // }
            },
        },
    },
    mounted() {
        if (this.category == null) {
            this.$store.dispatch("posts/getAll")
        } else {
            this.$store.dispatch("categories/getOne", this.category)
        }

        if (this.categories != null) {
            this.$store.dispatch("categories/getOne", this.categories.join(','))
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/queries";
@import "@/assets/scss/colors";
@import "@/assets/scss/fonts";

@keyframes fade {
    from {
        opacity: 0
    }

    ;

    to {
        opacity: 1
    }

    ;
}

.news {
    --news-padding: 1rem 0 2rem;
    --news-menu-margin: 0 0 2rem var(--side-padding);
    --menu-height: 5rem;
    --news-items-per-slide: 1;
    --news-items-gap: 1rem;
    --news-items-title-size: 1rem;
    --news-track-padding: 0 var(--side-padding);
    --news-menu-border: 0 0 0 .5rem;
    --news-meta-date-size: 0.5rem;
    --news-meta-gap: 1rem;
    --news-excerpt-size: 0.75rem;
    --news-width: 100%;

    @include media(sm) {
        --news-padding: 0 0 4rem 0;
        --news-menu-margin: 4rem 0 2rem;
        --news-items-gap: 3rem;
        --news-items-per-slide: 2;
        --news-items-title-size: 1.25rem;
        --news-track-padding: 0 calc(var(--content-width) * .065 * .5);
        --news-meta-date-size: 0.70613rem;
        --news-meta-gap: 2rem;
        --news-excerpt-size: 0.875rem;
        --news-width: var(--content-width);
    }

    @include media(md) {
        --news-items-title-size: 1.5rem;
    }

    @include media(lg) {
        --news-items-title-size: 1.75rem;
        --news-items-per-slide: 3;
    }

    margin: auto;

    width: var(--news-width);
    padding: var(--news-padding);

    &_actions {
        grid-area: actions;

        .button {
            padding: 0.59088rem 1.18175rem;
            font-size: 0.51206rem;
            font-style: normal;
            font-weight: 900;
        }
    }

    &_buttons {
        justify-content: center;

        :deep(.slider-control) {
            @include media(sm, $max-break: lg) {
                &:nth-child(even) {
                    display: none;
                }
            }

            @include media(lg) {

                &:nth-child(3n-1),
                &:nth-child(3n) {
                    display: none;
                }
            }
        }

    }

    &_menu {
        margin: var(--news-menu-margin);
        border: solid $color-betano;
        border-width: var(--news-menu-border);
    }

    &_highlightImage {
        grid-area: highlight;
        position: relative;
        min-width: 0;
        width: 100%;
        height: 0;
        padding: calc(100% * 9 / 16) 0 0 0;
    }

    &_navigation {
        grid-area: highlight;
        z-index: 10;
        position: absolute;
        pointer-events: none;
        top: 0;
        left: var(--side-padding);
        right: var(--side-padding);
        margin: auto 0;
        display: flex;
        justify-content: space-between;
        height: calc(var(--content-width) * .567);

        @include media(sm) {
            bottom: 0;
            left: 0;
            right: 0;
            height: calc(var(--content-width) * .167);
        }

        img {
            margin: auto 0;
            width: calc(var(--content-width) * .065 * .9 * 3);
            height: 100%;
            pointer-events: all;
            padding: 0 var(--side-padding);

            @include media(sm) {
                height: calc(var(--content-width) * .065 * .4);
                width: calc(var(--content-width) * .065 * .4);
                padding: 0;
            }

            &.left {
                transform: rotate(180deg);
            }

        }
    }

    &_meta {
        grid-area: meta;
        display: flex;
    }
}

.news {
    &_track {
        display: flex;
        gap: var(--news-items-gap);
        padding: var(--news-track-padding);
        overflow: hidden;
        position: relative;
    }

    &_item {
        --news-items-width: calc((100% / var(--news-items-per-slide)) - ((var(--news-items-per-slide) - 1) * var(--news-items-gap)) / var(--news-items-per-slide));

        flex-grow: 1;
        flex-basis: 0;
        display: grid;
        gap: var(--news-meta-gap);
        grid-template-rows: repeat(2, min-content) 1fr min-content;
        grid-template-areas:
            "highlight"
            "meta"
            "description"
            "actions"
        ;
        flex-direction: column;
        width: var(--news-items-width);
        max-width: var(--news-items-width);
        min-width: var(--news-items-width);
        text-decoration: none;

        animation-name: fade;
        animation-fill-mode: forwards;
        animation-timing-function: ease-out;
        animation-duration: .4s;

        @include media(sm, true) {
            &:not(:first-of-type) {
                display: none;
            }
        }

        &-placeholder {

            @include media(sm, true) {
                &:not(:first-of-type) {
                    display: none;
                }
            }

            .news_highlightImage {
                background-color: $color-betano;
                opacity: .75;

                img {
                    display: none;
                }
            }

            .newsMeta_description {
                h3 {
                    background-color: $color-betano;
                    border-radius: 1em;
                    height: 1em;
                }

                p {
                    background-color: #6E85A0;
                    height: 1rem;
                    border-radius: 1rem;
                }
            }
        }

        h3 {
            color: $color-betano;
            font-family: $ff-headings;
            font-size: var(--news-items-title-size);
            font-weight: 700;
            line-height: normal;
            text-transform: uppercase;
            margin-bottom: var(--news-meta-gap);
        }

        p {
            --max-lines: 3;
            --lh: #{0.875rem * 2};
            color: #6E85A0;
            font-family: $ff-regular;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: var(--lh);
            position: relative;
            max-height: calc(var(--lh) * var(--max-lines));
            overflow: hidden;
        }
    }
}


.newsMeta {

    &_date {
        color: $color-betano;
        text-decoration: none;
        font-size: var(--news-meta-date-size);
        margin: auto 0 auto 1em;
    }

    &_description {
        grid-area: description;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        text-decoration: none;

        :deep(p) {
            margin-top: auto;
            // color: #6E85A0;
            color: green;
            font-size: var(--news-excerpt-size);
            font-style: normal;
            font-weight: 400;
            line-height: 2;
        }
    }
}

h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: $color-betano;
    text-transform: uppercase;
    font-style: italic;
    font-weight: bold;
    background-color: #1E2D40;
    padding: 0 1rem;
    height: calc(var(--menu-height) / 2);
    display: flex;
    align-items: center;
    position: relative;
    z-index: 4;
    margin: 0;
    // Typography
    color: $color-betano;
    font-family: Glober;
    font-size: 1.321rem;
    font-style: italic;
    font-weight: 900;
    line-height: normal;
    text-transform: uppercase;

    span {
        display: inline-block;
        transform: translateY(.1em);
    }
}

.menu_track {
    width: 100%;
    overflow: auto;
}

.menu {
    --nr-of-items: 6;
    --selected-category: 0;
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat(var(--nr-of-items), 1fr);

    @include media(sm, true) {
        width: fit-content;
    }

    @include media(sm) {
        display: flex;
    }

    &::after {
        content: '';
        width: calc((100% / var(--nr-of-items)) + 1px);
        height: 100%;
        background: $color-betano;
        display: block;
        position: absolute;
        top: 0;
        z-index: 0;
        transition: left .2s ease-out;
        left: calc((100% / var(--nr-of-items)) * var(--selected-category) - 1px);
    }

    &_button {
        text-transform: uppercase;
        background: rgba(255, 102, 0, 0.10);
        color: $color-betano;
        font-style: italic;
        border: none;
        flex-grow: 1;
        flex-basis: 0;
        width: var(--button-width);
        position: relative;
        padding: 0 1rem;
        z-index: 1;
        // Typography
        text-align: center;
        font-family: Glober;
        font-size: 0.77638rem;
        font-style: italic;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        // Effects
        cursor: pointer;
        transition: .2s ease-out;
        transition-property: background, color;
        height: calc(var(--menu-height) / 2);

        &:hover {
            background: rgba(255, 102, 0, 0.20);
        }

        &.active {
            // background: $color-betano;
            color: #fff;
        }

        &:not(:last-child) {

            &::after {
                --border-height: calc((var(--menu-height) / 2) * .8);
                content: '';
                width: 1px;
                height: var(--border-height);
                background: $color-betano;
                display: block;
                position: absolute;
                right: 0;
                bottom: calc(((var(--menu-height) / 2) - var(--border-height)) / 2);
            }
        }

        span {
            display: inline-block;
            transform: translateY(.1em);
        }
    }
}
</style>
